import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import robot1 from '../assets/images/robot1.png';
import robot2 from '../assets/images/robot2.png';

const CallToAction = () => {
    const { t } = useTranslation();

    return (
        <section className="float-left w-100 position-relative call-to-action-con main-box padding-bottom">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="cta-inner-con padding-top100 padding-bottom100 position-relative">
                    <figure><img src={robot1} alt="robot" className="img-fluid position-absolute robot1 animated-robot" /></figure>
                    <figure><img src={robot2} alt="robot" className="img-fluid position-absolute robot2 animated-robot" /></figure>
                    <div className="heading-title-con text-center mb-0">
                        <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">{t('cta_title')}</span>
                        <h2 className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.4s" dangerouslySetInnerHTML={{ __html: t('cta_subtitle') }}></h2>
                        <p className="wow animate__animated animate__fadeInDown" data-wow-duration="2s" data-wow-delay="0.5s">{t('cta_desc')}</p>
                        <a href="/about" className="text-decoration-none primary_btn d-inline-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.6s">
                            {t('banner_get_started')}
                        </a>
                        <a href="/contact" className="text-decoration-none secondary_btn d-inline-block wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.7s">
                            {t('banner_live_demo')}
                        </a>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default CallToAction;